<div>
  <form [formGroup]="teamMemberForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-6">
    <!-- Team Member Image Upload -->
    <div class="flex flex-col gap-4">
      <label class="font-medium">{{ 'projectEdit.teamMembers.image' | translate }}</label>

      <!-- File Upload -->
      <p-fileUpload
        mode="basic"
        name="memberImage"
        accept="image/*"
        [maxFileSize]="5000000"
        (onSelect)="onImageSelect($event)"
        [auto]="true"
        [chooseLabel]="'projectEdit.teamMembers.chooseImage' | translate"
        chooseIcon="pi pi-image"
        class="w-fit"
      />

      <!-- Image Preview -->
      @if (imagePreview) {
      <div class="relative w-fit">
        <img
          [src]="
            imagePreview
              ? imagePreview.startsWith('data:') ||
                imagePreview.startsWith('http') ||
                imagePreview.startsWith('blob:')
                ? imagePreview
                : (imagePreview | adminImageSrc : projectId : {})
              : null
          "
          alt="Team member preview"
          class="w-32 h-32 object-cover rounded-full border"
        />
        <p-button
          icon="pi pi-times"
          [rounded]="true"
          [outlined]="true"
          (onClick)="removeImage()"
          class="absolute top-0 right-0"
          [title]="'projectEdit.teamMembers.removeImage' | translate"
        />
      </div>
      }

      <!-- Image Required Error -->
      @if (imageControl.invalid && imageControl.touched) {
      <p-message severity="error">
        {{ 'projectEdit.errors.teamMemberImageRequired' | translate }}
      </p-message>
      }
    </div>

    <!-- Name Field -->
    <div class="flex flex-col gap-2">
      <label for="memberName" class="font-medium">{{
        'projectEdit.teamMembers.name' | translate
      }}</label>
      <input
        id="memberName"
        type="text"
        pInputText
        [formControl]="nameControl"
        [placeholder]="'projectEdit.teamMembers.namePlaceholder' | translate"
        class="w-full"
      />
      @if (nameControl.invalid && nameControl.touched) {
      <p-message severity="error">
        {{ getNameErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Position Field -->
    <div class="flex flex-col gap-2">
      <label for="memberPosition" class="font-medium">{{
        'projectEdit.teamMembers.position' | translate
      }}</label>
      <input
        id="memberPosition"
        type="text"
        pInputText
        [formControl]="positionControl"
        [placeholder]="'projectEdit.teamMembers.positionPlaceholder' | translate"
        class="w-full"
      />
      @if (positionControl.invalid && positionControl.touched) {
      <p-message severity="error">
        {{ getPositionErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- LinkedIn URL Field -->
    <div class="flex flex-col gap-2">
      <label for="memberLinkedin" class="font-medium">{{
        'projectEdit.teamMembers.linkedinUrl' | translate
      }}</label>
      <input
        id="memberLinkedin"
        type="url"
        pInputText
        [formControl]="linkedinUrlControl"
        [placeholder]="'projectEdit.teamMembers.linkedinUrlPlaceholder' | translate"
        class="w-full"
      />
      @if (linkedinUrlControl.invalid && linkedinUrlControl.touched) {
      <p-message severity="error">
        {{ getLinkedinUrlErrorMessage() }}
      </p-message>
      }
    </div>

    <!-- Description Field -->
    <div class="flex flex-col gap-2">
      <label for="memberDescription" class="font-medium">{{
        'projectEdit.teamMembers.description' | translate
      }}</label>
      <textarea
        id="memberDescription"
        [formControl]="descriptionControl"
        [placeholder]="'projectEdit.teamMembers.descriptionPlaceholder' | translate"
        rows="4"
        maxlength="250"
        (input)="onDescriptionInput($event)"
        (keydown)="onDescriptionKeydown($event)"
        (paste)="onDescriptionPaste($event)"
        class="w-full border border-gray-300 rounded px-3 py-2"
      ></textarea>
      <div class="flex justify-between items-start gap-2">
        <div class="flex-1">
          @if (showDescriptionMaxLengthError) {
          <p-message severity="error">
            {{ 'projectEdit.errors.teamMemberDescriptionMaxLength' | translate }}
          </p-message>
          } @else if (descriptionControl.invalid && descriptionControl.touched) {
          <p-message severity="error">
            {{ getDescriptionErrorMessage() }}
          </p-message>
          }
        </div>
        <span class="text-sm text-muted"> {{ descriptionControl.value?.length || 0 }}/250 </span>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="flex flex-col md:flex-row gap-4 mt-6">
      <p-button
        type="submit"
        [label]="
          isEdit
            ? ('projectEdit.teamMembers.updateMember' | translate)
            : ('projectEdit.teamMembers.addMember' | translate)
        "
        [disabled]="teamMemberForm.invalid"
      />

      <p-button
        type="button"
        [label]="'projectEdit.cancel' | translate"
        severity="secondary"
        [outlined]="true"
        (onClick)="onCancel()"
      />
    </div>
  </form>
</div>
